module.exports = "<a class=\"nav-link\" routerLink=\"/{{routePath}}\">{{ routeTitle }}</a>"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/layouts/footer/plan-site/plan-site-item/plan-site-item.component.html
// module id = 814
// module chunks = 0